<header
  *upuTranslate="let t"
  upuScrollObserver
  [(hasScrolled)]="hasScrolled"
  [scrollSentinelId]="'top-bar-observer'"
  targetSelector="root"
  class="fixed top-0 w-full z-50 py-4 px-12 before:absolute before:top-0 before:h-1/2 before:left-0 before:right-0 before:z-0 before:mx-12 before:bg-gradient-to-b from-background to-transparent overflow-hidden"
>
  <div
    class="relative h-16 frost-effect-sm grid grid-cols-3 px-4 rounded-2xl border [&.active-scroll-style]:border-[#B5D6E8]/50 transition-colors duration-150 before:absolute before:inset-0 before:-z-10 before:rounded-2xl before:shadow-lg before:shadow-[#E5F0F6]/70 before:opacity-0 before:transition-opacity before:duration-150 [&.active-scroll-style]:before:opacity-100"
    [class.active-scroll-style]="hasScrolled()"
  >
    <div
      class="flex items-center gap-3"
      routerLink="/home"
      [style]="{ cursor: 'pointer' }"
      [title]="t('topBar.goHome')"
    >
      <figure class="shrink-0">
        <img
          [alt]="t('topBar.upuLogo')"
          class="h-[42px] select-none"
          src="assets/upu-logo.svg"
          loading="eager"
          draggable="false"
        />
      </figure>

      <mat-divider class="h-9 border-primary" vertical />

      <span
        class="text-primary text-sm font-medium uppercase max-w-56 text-start select-none"
      >
        {{ t('topBar.securityCertification') }}
      </span>
    </div>

    <nav class="flex items-center justify-center gap-2">
      @for (link of navigationLinks(); track link.id) {
        @if (!link.hidden) {
          <a
            #al="routerLinkActive"
            [id]="link.id"
            class="icon-button w-fit px-4 h-10 gap-2 rounded-xl text-primary font-semibold [&.active]:bg-primary-highlight before:bg-primary/5 [&.active]:before:opacity-0"
            routerLinkActive="active"
            [routerLink]="[link.route]"
          >
            <mat-icon class="text-xl" [class.mat-symbol-filled]="al.isActive">
              {{ link.icon }}
            </mat-icon>
            <span>{{ t(link.label) }}</span>
          </a>
        }
      }
    </nav>

    <div class="justify-self-end flex items-center gap-3">
      <upu-notification-button />
      <upu-user-menu />
    </div>
  </div>
</header>
